import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelperService } from '../services/helper.service';
import { ApiResponse } from '../models/api-response';
import { User } from '../models/user';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private helperService: HelperService, private baseService: BaseService) { }

  private get tokenHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return headers;
  }

  attempt(email: string, password: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/token`,
      `username=${email}&password=${this.helperService.hash(password)}&grant_type=password`,
      { headers: this.tokenHeaders }
    );
  }

  userPasswordChangeRequest(userEmail: string): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${environment.apiUrl}/${environment.apiVersion}/auth/user-password-change-request`, { userEmail });
  }

  userPasswordSetByRequestKey(userEmail: string, requestKey: string, password: string): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${environment.apiUrl}/${environment.apiVersion}/auth/user-password-set-by-request-key`, { userEmail, requestKey, inputPasswordHash: this.helperService.hash(password) });
  }

  logon(): Observable<ApiResponse<User>> {
    return this.baseService.executeCommand<User>('portal_user_logon_trace_start', {
      applicationCode: environment.appCode,
      versionCode: environment.appVersion,
      osDomain: null,
      osUser: null,
      osPlatform: null,
      machineId: null,
    });
    // return this.http.post<ApiResponse<User>>(`${environment.apiUrl}/${environment.apiVersion}/auth/portal-user-logon-trace-start`, {
    //   applicationCode: environment.appCode,
    //   versionCode: environment.appVersion,
    //   osDomain: null,
    //   osUser: null,
    //   osPlatform: null,
    //   machineId: null
    // });
  }

}
